/** ponytail: Spanish-only UI labels (no i18n layer) */

export const orderStatusLabel: Record<string, string> = {
  pending: 'Pendiente',
  confirmed: 'Confirmado',
  preparing: 'En preparación',
  ready: 'Listo',
  served: 'Servido',
  completed: 'Completado',
  cancelled: 'Cancelado',
}

export const paymentStatusLabel: Record<string, string> = {
  pending: 'Pendiente',
  completed: 'Completado',
  failed: 'Fallido',
  refunded: 'Reembolsado',
}

export const paymentMethodLabel: Record<string, string> = {
  cash: 'Efectivo',
  card: 'Tarjeta',
  credit_card: 'Tarjeta de crédito',
  debit_card: 'Tarjeta de débito',
  digital_wallet: 'Billetera digital',
  digital: 'Digital',
}

export const orderTypeLabel: Record<string, string> = {
  dine_in: 'En mesa',
  takeaway: 'Para llevar',
  takeout: 'Para llevar',
  delivery: 'A domicilio',
}

export const tableStatusLabel: Record<string, string> = {
  available: 'Disponible',
  occupied: 'Ocupada',
  reserved: 'Reservada',
  maintenance: 'En mantenimiento',
}

export const roleLabel: Record<string, string> = {
  admin: 'Administrador',
  manager: 'Gerente',
  server: 'Mesero',
  counter: 'Caja',
  kitchen: 'Cocina',
}

export function statusLabel(status: string, map: Record<string, string> = orderStatusLabel): string {
  return map[status] ?? status
}
